export const Login = 'member/token';

// energy Efficiency App
export const GetPerformanceTrackers = 'energyefficiency/performancetrackers';
export const GetPerformanceTrackersByClientId =
  'energyefficiency/pftrackersbyclientbyuser';
export const GetPerformanceAlerts = 'energyefficiency/pfalertsbyclientbyuser';
export const GetNotesByAlertIdAndAlertType = 'actionnotes/';
export const SaveNotes = 'actionnotes';
export const GetDivision = 'appsconfig/division';
export const GetDivisionByClient = 'appsconfig/divisionsbyclient/';
export const GetFeederByLocation = 'appsconfig/productsbyassetpoint/';
export const GetLocationByDivision = 'monitoring/primsubstbyuseridbydivid';
export const GetVoltageCharts = 'report/voltageforecast/';
export const GetReliabilityCharts = 'report/reliabilityprofile/';
export const GetPhasorCharts = 'assetpoint/listassetpoints/';
export const GetDemandCharts = 'report/realpowerdemand/';
export const GetFrequencyCharts = 'report/frequencyprofile/';
export const GetPeakDemandProfile =
  'report/peakdemandprofiledatabyassetpointid/';
export const GetPhasorDiagramData = 'report/phasordiagram/';
export const GetPhasorInstantaneousData = 'report/feederinstantaneousdata/';

export const GetPerformanceAlertsChields = 'energyefficiency/pachilddata';
export const MoveToHistoric = 'energyefficiency/movetohistoric';
export const MoveToArchive = 'energyefficiency/movetoarchive';
export const GetDetailByAlertId = 'energyefficiency/performancealertsbyalertid';
export const GetSLDData = 'sld/getvaluesbyassetpointid/';

export const GetProducts = 'appsconfig/product/';
export const GetDailyReportByDateAndID = 'product/getdataforcsvbysearch';

// fault app
export const GetTableOfFaults = 'faultdata/faultsbyuserrole';
export const GetPrimaryNode = 'monitoring/primsubstbyuserid';

export const DASHBOARD_APP_TABS = {
  MAP: 'Map',
  SLD: 'SLD',
  FAULTS: 'Faults',
  ANALOG_LOG: 'Analog Log',
  EVENT_LOG: 'Event Log',
  ASSET: 'Asset',
};

export const LevelTypes = {
  location: 'location',
  division: 'division',
  asset: 'asset',
  level: 'level',
};

export const constants = {
  core: {
    NO_DATA_MSG: 'No data returned...',
    REPORT_SUCCESS_MSG:
      'Your report getting download, Please check on your local drive.',
    SOMETHING_WENT_WRONG: 'Something went wrong...',
    EMPTY_MSG: '',
    DIVISION: 'division',
    ASSET_POINT: 'assetpoint',
    FEEDER: 'feeder',
    EMPTY_CHART_MSG: 'No data found to display!',
    APPS: {
      ENERGY_EFFICIENCY: 'ENERGY_EFFICIENCY',
      FAULT: 'FAULT',
      ASSET: 'ASSET',
      LOWCARBON: 'LOW CARBON',
      REPORT_EXPORT: 'REPORT_EXPORT',
      SUBSTATION_HEALTH: 'Substation Health',
    },
    ANALYTICS_APPS: {
      ENERGY_EFFICIENCY: 'Energy Efficiency',
      FAULT: 'Faults',
      ASSET: 'Asset Health',
    },
    ANALYTICSTABS: {
      ENERGY_EFFICIENCY: [
        'Energy',
        'Reliability',
        'Demand',
        'Forecast',
        'Quality Check',
      ],
      FAULT: ['Fault Trends', 'Feeder Curves'],
      LOWCARBON: ['Site Analytics', 'Energy Consumption', 'Power Flow'],
      ASSET: ['Live Readings', 'Permissible Loading', 'Battery'],
    },
    TABS: {
      ENERGY_EFFICIENCY: {
        ENERGY: 'Energy',
        RELIABILITY: 'Reliability',
        DEMAND: 'Demand',
        FORECAST: 'Forecast',
        QUALITY_CHECK: 'Quality Check',
      },
      FAULT: {
        FAULT_TRENDS: 'Fault Trends',
        FEEDER_CURVES: 'Feeder Curves',
      },
      LOWCARBON: {
        SITE_ANALYTICS: 'Site Analytics',
        ENERGY_CONSUMPTION: 'Energy Consumption',
        POWER_FLOW: 'Power Flow',
      },
      ASSET: {
        LIVE_READINGS: 'Live Readings',
        PERMISSIBLE_LOADING: 'Permissible Loading',
        BATTERY: 'Battery',
      },
    },
    REPORTS_TYPE: {
      SINGLE_DATE: 'SingleDate',
    },
    APP_LIST: {
      DASHBOARD: 'Dashboard',
      EE: 'Energy Efficiency',
      ASSET_HEALTH_MONITORING: 'Asset Health',
      FAULTS_APP: 'Faults',
    },
  },
  default: {
    EMPTY_STRING: '',
    EMPTY_ARRAY: [],
    EMPTY_OBJECT: {},
    EMPTY_BOOL: false,
  },
  toast: {
    SUCCESS: 'success',
    ERROR: 'error',
  },
  reportType: {
    HISTORIC: 'Historic',
    REALTIME: 'Realtime',
  },
  electricityType: {
    VOLTAGE: 'Voltage',
    CURRENT: 'Current',
  },
  color: {
    RED: '#da532c',
    YELLOW: '#FFFF00',
    BLUE: '#2d89ef',
  },
  status: {
    SYNC: 'SYNC',
    NO_SYNC: 'NO_SYNC',
  },
  colorObj: [
    '#2b5454',
    '#4ea76a',
    '#f01934',
    '#a0522d',
    '#b86a4b',
    '#000',
    '#de2f45',
    '#689f38',
    '#2d89ef',
    '#FFFF00',
    '#da532c',
  ],
  colorObjLC: {
    solar: '#dcb63c',
    battery: '#9faa3a',
    site: '#ba403d',
    grid: '#3f9de2',
  },
  colorObjLCForecast: {
    solar: '#e9d16b',
    battery: '#d1d7a3',
    site: '#dca09e',
    grid: '#8acceb',
  },
  hirarchyAPI: {
    byUser: {
      client: 'circle/circlesbyuser/',
      circle: 'circle/circlesbyuser/',
      division: 'division/divisionsbyuser/',
      town: 'town/townsbyuser/',
      subdivision: 'subdivision/subdivisionbyuser/',
      section: 'section/sectionsbyuser/',
      substation: 'substation/substationsbyuser/',
      asset: 'asset/assetsbyuser/',
    },
    byClient: {
      client: 'circle/circlesbyclient/',
      circle: 'circle/circlesbyclient/',
      division: 'division/divisionsbyclient/',
      town: 'town/townsbyclientid/',
      subdivision: 'subdivision/subdivisionsbyclientid/',
      section: 'section/sectionsbyclientid/',
      substation: 'substation/substationsbyclientid/',
      asset: 'asset/assetsbyclientassettype/',
    },
    byHirarchy: {
      client: 'circle/circlesbyclient',
      circle: 'division/divisionsbycircle',
      division: 'town/townsbydivisionid',
      town: 'subdivision/subdivisionsbytownid',
      subdivision: 'section/sectionsbysubdivid',
      section: 'substation/substationsbysectionid',
      substation: 'asset/assetsbyassetpoint',
    },
  },
  Months: [
    {
      value: '01',
      name: 'January',
    },
    {
      value: '02',
      name: 'February',
    },
    {
      value: '03',
      name: 'March',
    },
    {
      value: '04',
      name: 'April',
    },
    {
      value: '05',
      name: 'May',
    },
    {
      value: '06',
      name: 'June',
    },
    {
      value: '07',
      name: 'July',
    },
    {
      value: '08',
      name: 'August',
    },
    {
      value: '09',
      name: 'September',
    },
    {
      value: '10',
      name: 'October',
    },
    {
      value: '11',
      name: 'November',
    },
    {
      value: '12',
      name: 'December',
    },
  ],
  networkSubColor: {
    '33/11': '#9a6500',
    '11/.44': '#008000',
    '132/33': '#333399',
  },
  REFRESH_ICON: {
    iconClass: 'fa fa-refresh fa_cutsom',
    id: 'icnRefresh',
    tooltip: 'refresh',
  },
};

export const sldImageBasePath = '/Images/IEEE1975/';
